import { render, staticRenderFns } from "./ContentEditForm.vue?vue&type=template&id=0c6b4739&"
import script from "./ContentEditForm.vue?vue&type=script&lang=ts&"
export * from "./ContentEditForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports